/** Choose a representative colour without letting black backgrounds or transparent padding dominate. */
export function avatarColor(pixels: Uint8ClampedArray): string | null {
  type Bucket = { weight: number; r: number; g: number; b: number }
  const all = new Map<number, Bucket>()
  const coloured = new Map<number, Bucket>()
  let visible = 0
  let chromatic = 0
  const add = (buckets: Map<number, Bucket>, r: number, g: number, b: number, weight: number) => {
    const key = ((r >> 5) << 6) | ((g >> 5) << 3) | (b >> 5)
    const bucket = buckets.get(key) ?? { weight: 0, r: 0, g: 0, b: 0 }
    bucket.weight += weight
    bucket.r += r * weight
    bucket.g += g * weight
    bucket.b += b * weight
    buckets.set(key, bucket)
  }
  for (let i = 0; i + 3 < pixels.length; i += 4) {
    const alpha = pixels[i + 3]! / 255
    if (alpha < 0.1) continue
    const r = pixels[i]!, g = pixels[i + 1]!, b = pixels[i + 2]!
    const max = Math.max(r, g, b), min = Math.min(r, g, b)
    visible += alpha
    add(all, r, g, b, alpha)
    // Monochrome avatars stay monochrome; tiny colour accents do not set the whole banner.
    if (max > 40 && max - min > 25 && (max - min) / max > 0.2) {
      chromatic += alpha
      add(coloured, r, g, b, alpha)
    }
  }
  const buckets = chromatic >= visible * 0.05 ? coloured : all
  let best: Bucket | undefined
  for (const bucket of buckets.values()) {
    if (!best || bucket.weight > best.weight) best = bucket
  }
  if (!best) return null
  const hex = (n: number) => Math.round(n / best.weight).toString(16).padStart(2, '0')
  return `#${hex(best.r)}${hex(best.g)}${hex(best.b)}`
}
